import type { FloatBlockConfig } from '@lighthouse/core'
import { FLEX_ALIGN, SubFormBlockConfig } from '@lighthouse/core'

export const generateFloatBlock = (
    mainBreakPoint: string,
    showOn: 'click' | 'hover',
    overlayType: 'relative' | 'fixed'
): FloatBlockConfig => {
    if (overlayType === 'fixed') {
        return {
            breakPoint: {
                id: mainBreakPoint,
                // name: '桌面端',
                visibility: {
                    visible: 'VISIBLE'
                },
                size: {
                    width: {
                        size: 100,
                        unit: 'vw'
                    },
                    height: {
                        size: 100,
                        unit: 'vh'
                    },
                    overflow: 'hidden'
                },
                layout: {
                    align: {
                        direction: 'vertical',
                        isDistributedAlignment: false,
                        alignX: FLEX_ALIGN['center'],
                        alignY: FLEX_ALIGN['center']
                    },
                    gap: {
                        size: 8,
                        unit: 'px'
                    },
                    padding: { size: [4, 4, 4, 4], unit: 'px' }
                },
                design: {
                    radius: [0, 0, 0, 0],
                    background: {
                        type: 'color',
                        color: '#000000cc'
                    },
                    blur: 0,
                    shadow: undefined
                },
                overlay: {
                    overlayType: 'fixed',
                    showOn: showOn ?? 'hover',
                    dismiss: showOn ?? 'hover',
                    position: 'bottom',
                    align: 'center',
                    offset: [0, 0],
                    autoPosition: true,
                    autoDistance: 16,
                    closeClickOutside: true
                }
            },
            breakPoints: [
                {
                    id: 'mobile'
                    // name: '移动端'
                }
            ]
        }
    }
    return {
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            size: {
                width: {
                    size: 200
                },
                height: {
                    size: 150
                },
                overflow: 'visible'
            },
            layout: {
                align: {
                    direction: 'vertical',
                    isDistributedAlignment: false,
                    alignX: FLEX_ALIGN['flex-start'],
                    alignY: FLEX_ALIGN['flex-start']
                },
                gap: {
                    size: 8,
                    unit: 'px'
                },
                padding: { size: [4, 4, 4, 4], unit: 'px' }
            },
            design: {
                radius: [10, 10, 10, 10],
                background: {
                    type: 'color',
                    color: '#ffffff'
                },
                blur: 0,
                shadow: {
                    x: 0,
                    y: 2,
                    diffusion: 2,
                    blur: 5,
                    color: '#00000014'
                }
            },
            overlay: {
                overlayType: 'relative',
                showOn: showOn ?? 'hover',
                dismiss: showOn ?? 'hover',
                position: 'bottom',
                align: 'center',
                offset: [0, 0],
                autoPosition: true,
                autoDistance: 16,
                closeClickOutside: false
            }
        },
        breakPoints: []
    }
}
